/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationProceduresAliases {
  ACTION_ADD_PROCEDURE = 'action-add-procedure',
  AUTOCOMPLETE_0 = 'autocomplete-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_ACTION = 'fetch-action',
  FETCH_LIST = 'fetch-list',
  FETCH_ORIGIN = 'fetch-origin',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FETCH_PROCEDURE = 'fetch-procedure',
  FETCH_SPECIALTIES = 'fetch-specialties',
  FIELD_0 = 'field-0',
  FIELD_ACTION = 'field-action',
  FIELD_CODE = 'field-code',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_FILM_VALUE = 'field-film-value',
  FIELD_FILM_VALUE_LIST = 'field-film-value-list',
  FIELD_MEDICAL_VALUE = 'field-medical-value',
  FIELD_NR_SEQUENCE_LIST = 'field-nrSequence-list',
  FIELD_OPERATIONAL_COST = 'field-operational-cost',
  FIELD_OPERATIONAL_COST_VALUE_LIST = 'field-operational-cost-value-list',
  FIELD_ORIGIN = 'field-origin',
  FIELD_PROCEDURE = 'field-procedure',
  FIELD_PROCEDURE_LIST = 'field-procedure-list',
  FIELD_SPECIALTY = 'field-specialty',
  FIELD_VALUE_MEDICAL_LIST = 'field-value-medical-list',
  FIELD_VALUE_PROCEDURE = 'field-value-procedure',
  FIELD_VALUE_PROCEDURE_LIST = 'field-value-procedure-list',
  FILTER_0 = 'filter-0',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_0 = 'form-0',
  FORM_PROCEDURE = 'form-procedure',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  INPUT_4 = 'input-4',
  INPUT_CODE = 'input-code',
  INPUT_DESCRIPTION = 'input-description',
  INPUT_LOCATOR = 'input-locator',
  INPUT_NR_SEQUENCE_LIST = 'input-nrSequence-list',
  LAYOUT_0 = 'layout-0',
  LEGENDS = 'legends',
  LOCATOR_FIELD_CD_PROCEDURE = 'locator-field-cdProcedure',
  LOCATOR_PROCEDURE = 'locator-procedure',
  MAPPER_0 = 'mapper-0',
  MAPPER_3 = 'mapper-3',
  MAPPER_10 = 'mapper-10',
  MAPPER_ORIGIN = 'mapper-origin',
  MODAL_ADD_NEW = 'modal-add-new',
  MY_DATA_CARD = 'my-data-card',
  MY_DATA_DECK = 'my-data-deck',
  PANEL_MODAL = 'panel-modal',
  PANEL_PENDENCIES = 'panel-pendencies',
  PANEL_SERVICE = 'panel-service',
  TEXT_0 = 'text-0',
  TEXT_3 = 'text-3',
  TEXT_3_LIST = 'text-3-list',
  TEXT_4_LIST = 'text-4-list',
  TEXT_5_LIST = 'text-5-list',
  TEXT_6_LIST = 'text-6-list',
  TEXT_ORIGIN = 'text-origin',
  TEXT_TYPE_LIST = 'text-type-list',
  TOAST_NOTIFICATION = 'toast-notification',
  UNBOXED_AUTOCOMPLETE_ACTION = 'unboxed-autocomplete-action',
  UNBOXED_SPECIALTY = 'unboxed-specialty',
}
export { AccreditationProceduresAliases };
